import { getKeycloakConfig } from './keycloakConfig';

/**
 * Register an FCM token on the Keycloak apexx-fcm-tokens SPI.
 */
export async function registerFcmToken(
	accessToken: string,
	body: { token: string; platform?: string; device_id?: string },
): Promise<void> {
	const { url, realm } = getKeycloakConfig();
	const endpoint = `${url}/realms/${realm}/apexx-fcm-tokens`;

	const response = await fetch(endpoint, {
		method: 'PUT',
		headers: {
			Authorization: `Bearer ${accessToken}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

	if (!response.ok) {
		throw new Error(`FCM register failed: ${response.status}`);
	}
}

/**
 * Unregister an FCM token from the Keycloak apexx-fcm-tokens SPI.
 */
export async function unregisterFcmToken(accessToken: string, token: string): Promise<void> {
	const { url, realm } = getKeycloakConfig();
	const endpoint = `${url}/realms/${realm}/apexx-fcm-tokens?token=${encodeURIComponent(token)}`;

	const response = await fetch(endpoint, {
		method: 'DELETE',
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	});

	if (!response.ok && response.status !== 204) {
		throw new Error(`FCM unregister failed: ${response.status}`);
	}
}
